module.exports = __webpack_public_path__ + "components/popular-cities-header/static/header--huge-37725a992ba527ec70cf2b22746aca69.jpg";